import { selectors } from 'app-webtech-core/selectors';
import { guidePropertiesSelector } from '../../../guide/selectors/properties';

export const getPlaybackData = (state) => {
  const { list, currentPlayingIndex } = guidePropertiesSelector(state);

  if (!list || list.length < currentPlayingIndex || currentPlayingIndex < 0) {
    return { channelName: 'na', channelID: 'na' };
  }

  const channelID = list[currentPlayingIndex].id || 'na';

  const { entities } = selectors.linearChannels.properties(state);
  let channelName = '';

  if (channelID && entities && entities.linearChannels && entities.linearChannels[channelID]) {
    channelName = entities.linearChannels[channelID].name || 'na';
  }

  return {
    titleID: channelID,
    titleName: channelName,
  };
};
